// extracted by mini-css-extract-plugin
export default {"packageLayout":"lottieLoader_packageLayout__njWJo","container":"lottieLoader_container__g7h4n"};